import OvertimeEvent from '@/components/requests/overtime/events/OvertimeEvent'

export default class CommentRestoredEvent extends OvertimeEvent {
  asText(viewer) {
    return `**${this.getActorName(viewer)}** restored a comment`
  }
}
